import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "@/i18n";

export const Values: React.FC = () => {
  const t = useTranslation();

  return (
    <>
      <div id="arbeitsweise"></div>
      <div className="bg-[#FAFAFB] py-[72px] md:py-[120px]">
        <div className="max-w-screen-xl m-auto px-[38px] 2xl:px-0">
          <h2 className="text-[#171A1F] font-bold text-[28px] leading-[38px] md:text-[44px] md:leading-[56px] max-w-3xl">
            {t.values.headline}
          </h2>

          <div className="mt-[40px] md:mt-[56px] grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {t.values.cards.map((value, index) => (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (index % 2) * 0.1 }}
                className="rounded-[20px] bg-white border border-base-200 p-[28px] md:p-[36px]"
              >
                <p className="text-[36px] md:text-[44px] font-bold text-[#01C6FB] leading-none">
                  {`0${index + 1}`}
                </p>
                <h3 className="mt-4 text-[19px] md:text-[22px] font-bold text-[#171A1F]">
                  {value.title}
                </h3>
                <p className="mt-2 text-[15px] leading-[25px] md:text-[16px] md:leading-[28px] text-base-600">
                  {value.text}
                </p>
              </motion.div>
            ))}
          </div>

          <p className="mt-[40px] md:mt-[48px] text-center text-[14px] md:text-[15px] text-base-500 max-w-2xl m-auto">
            {t.values.footnote}
          </p>
        </div>
      </div>
    </>
  );
};
